export default "__VITE_ASSET__bIMEh2or__"